import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { TranslationService } from '../../../../services/translation/translation.service';
import { SchoolDataService } from '../../../../services/school-data/school-data.service';
import { SchoolData } from '../../../../models/school-data/schooldata';
import { fuseAnimations } from '../../../../../core/animations';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { ShiftService } from '../../../../services/shifts/shift.service';
import { AddSchoolDataDto } from '../../../../models/school-data/dto/AddSchoolDataDto';
import { EmployeeService } from '../../../../services/employee/employee.service';
import { Shift } from '../../../../models/shifts/shift';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'fuse-school-data',
    templateUrl: './school-data.component.html',
    styleUrls: ['./school-data.component.scss'],
    animations: fuseAnimations
})
export class SchoolDataComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    public schoolData: SchoolData = new SchoolData();
    public minHoraStart: Date;
    public minHoraFinish: Date;

    constructor(private authenticationService: AuthenticationService,
                public dialog: MatDialog,
                private location: Location,
                public schooldataService: SchoolDataService,
                public shiftService: ShiftService,
                private router: Router,
                private route: ActivatedRoute,
                private fb: FormBuilder,
                private translationService: TranslationService,
                private translateService: TranslateService,
                private sweetAlertService: SweetAlertService) {

    }

    ngOnInit(): void {
        this.blockUI.start('Cargando datos...');
        this.schooldataService.getData().subscribe(response => {
            this.blockUI.stop();
            console.log('SchoolDataComponent > ngOnInit > this.schooldataService.getdata()', response);
            this.schoolData = response;
            for (const r of this.schoolData.shifts) {
                r.EntryTime = new Date(r.EntryTime + 'Z');
                r.DepartureTime = new Date(r.DepartureTime + 'Z');
            }
        }, error => {
            this.blockUI.stop();
            this.sweetAlertService.error('Error', 'Ocurrio un error al traer los turnos.', null);
        });
    }

    save() {
        this.blockUI.start('Guardando datos...');
        const schooldataDTO = new AddSchoolDataDto();

        schooldataDTO.Id = this.schoolData.Id;
        schooldataDTO.Number = this.schoolData.Number;
        schooldataDTO.Name = this.schoolData.Name;
        schooldataDTO.Mail = this.schoolData.Mail;
        schooldataDTO.Address = this.schoolData.Address;
        schooldataDTO.PhoneNumber = this.schoolData.PhoneNumber;
        schooldataDTO.shifts = this.schoolData.shifts;

        this.schooldataService.add(schooldataDTO).subscribe(response => {
            this.translateService.get('LABELS.DATA_SAVED_CORRECTLY').subscribe(res => {
                this.sweetAlertService.success('', res);
            });

            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    public calculaMinDate(shift: Shift) {
        const fechaInicio = new Date(2018, 0, 1, shift.EntryTime.getHours(), shift.EntryTime.getMinutes(), shift.EntryTime.getSeconds());
        shift.EntryTime = fechaInicio;
        this.minHoraFinish = shift.EntryTime;
        console.log(fechaInicio);
    }

    public calculaMinDateFin(shift: Shift) {
        const fechaInicio = new Date(2018, 0, 1, shift.DepartureTime.getHours(), shift.DepartureTime.getMinutes(), shift.DepartureTime.getSeconds());
        shift.DepartureTime = fechaInicio;
        this.minHoraStart = shift.DepartureTime;
        console.log(fechaInicio);
    }

    ngOnDestroy(): void {
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/school-data/school-data.component.ts